import Vue from 'vue'
import Router from 'vue-router'
import Auth from '../components/Auth.vue';
import Dashboard from '../components/Dashboard'
import Schools from '../components/Schools'
import Categories from '../components/Categories'
import Questions from '../components/Questions'
import Quests from '../components/Quests'
import Users from '../components/Users'
import Map from '../components/Map'
import Rankings from '../components/Rankings'
import Players from '../components/Players'
import PlayerExports from '../components/Exports'

Vue.use(Router)

export default new Router({
  routes: [
    { path: '/', component: Auth },
    { path: '/auth', component: Auth },
    { path: '/dashboard', component: Dashboard },
    { path: '/categories', component: Categories },
    { path: '/categories/:cid/questions', component: Questions },
    { path: '/quests', component: Quests },
    { path: '/schools', component: Schools },
    { path: '/users', component: Users },
    { path: '/map', component: Map },
    { path: '/rankings', component: Rankings },
    { path: '/players', component: Players },
    { path: '/playerexports', component: PlayerExports },
    { path: '/*', component: Dashboard }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js